/**
 * ClesBatimentsPage — gestion des clés (item 11.1).
 *
 * Rattachée au service technique, comme les visites ERP et les contrats : c'est
 * le même parc bâtimentaire. La GRC y accède aussi — elle remet les clés des
 * salles réservées — via ses propres permissions `grc.cle.*`.
 */
import { AppHeader } from '@/components/AppHeader';
import { ServiceTechniqueNav } from '@/components/ServiceTechniqueNav';
import { ClesBatimentsPanel } from './ClesBatimentsPanel';

export function ClesBatimentsPage() {
  return (
    <>
      <AppHeader module="Service technique" accent="tech" />
      <ServiceTechniqueNav active="cles" />
      <main id="main-content" className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <ClesBatimentsPanel />
      </main>
    </>
  );
}
